import { useTranslation } from 'react-i18next';
import { ArrowRight, ExternalLink, Shield, RefreshCw, Globe, BookOpen } from 'lucide-react';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Overhead%20flatlay%20of%20curated%20fashion%20items%20including%20sneakers%20hoodie%20sunglasses%20and%20a%20leather%20bag%20arranged%20on%20a%20soft%20sage%20green%20background%2C%20bright%20airy%20natural%20light%2C%20modern%20editorial%20product%20photography%2C%20fresh%20clean%20aesthetic%20with%20subtle%20shadows%20and%20organic%20composition&width=1920&height=1080&seq=hero-main-bg-401&orientation=landscape&nocache=true"
          alt="AllChinaBuy Spreadsheet Fashion Products"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/40 via-foreground-950/30 to-foreground-950/50" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-8 xl:px-12 pt-28 md:pt-36 pb-20 md:pb-28">
        <div className="max-w-4xl mx-auto text-center">
          <span className="inline-block px-4 py-1.5 mb-6 text-xs font-semibold tracking-widest uppercase text-background-100 bg-background-950/30 backdrop-blur-sm rounded-full border border-background-100/20 animate-fade-in-up">
            {t('hero.eyebrow')}
          </span>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-6 animate-fade-in-up" style={{ animationDelay: '0.1s' }}>
            {t('hero.title')}
          </h1>

          <p className="text-base md:text-lg text-background-100/90 max-w-2xl mx-auto mb-8 leading-relaxed animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
            {t('hero.description')}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4 mb-10 animate-fade-in-up" style={{ animationDelay: '0.3s' }}>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="group inline-flex items-center gap-2 px-6 md:px-8 py-3 md:py-4 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-xl transition-all duration-300 whitespace-nowrap"
            >
              {t('hero.cta1')}
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="group inline-flex items-center gap-2 px-6 md:px-8 py-3 md:py-4 bg-background-50/20 hover:bg-background-50/30 backdrop-blur-sm text-background-50 font-semibold rounded-xl border border-background-100/30 transition-all duration-300 whitespace-nowrap"
            >
              {t('hero.cta2')}
              <ExternalLink className="w-4 h-4" />
            </a>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 text-background-100/80 text-xs md:text-sm animate-fade-in-up" style={{ animationDelay: '0.4s' }}>
            <span className="flex items-center gap-1.5">
              <Shield className="w-4 h-4" />
              Independent Resource
            </span>
            <span className="flex items-center gap-1.5">
              <RefreshCw className="w-4 h-4" />
              Updated Regularly
            </span>
            <span className="flex items-center gap-1.5">
              <Globe className="w-4 h-4" />
              Multilingual
            </span>
            <span className="flex items-center gap-1.5">
              <BookOpen className="w-4 h-4" />
              Safety Guides
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}